<template>
  <ul>
    <li v-for="(item, i) in list" :key="i">
      <router-link :to="item.path" class="menu__item">
        <img :src="item.meta.icon">
        {{ item.meta.title }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MenuLeft',
  props: {
    list: {
      type: Object,
      required: true,
    },
  },
  computed: {

  },
  methods: {

  },
}
</script>
